module.exports = __webpack_public_path__ + "img/protect-privacy-dark.2c1adda3.svg";